<template>
  <v-col :cols="options.grid" v-if="this.link">
    <DynamicFormShard
      :answerableId="answerableId"
      :answerableType="answerableType"
      :shard="shard"
      :depth="depth"
      :hideTitle="hideTitle"
      :readOnly="readOnlyOption"
      :parentAnswerGroup="parentAnswerGroup"
      :parentCreateAnswerGroup="parentCreateAnswerGroup"
      :refreshForm="refreshForm"
    >
      <template v-slot:useButton="{ shard }">
        <slot name="useButton" v-bind:shard="shard"></slot>
      </template>
    </DynamicFormShard>
  </v-col>
</template>

<script>
  import DynamicFormShard from "@/components/dynamic_form/shard/index.vue";

  export default {
    name: "DynamicFormLink",
    props: {
      answerableId: String,
      answerableType: String,
      link: Object,
      readOnly: {
        type: Boolean,
        default: false,
      },
      hideTitle: {
        type: Boolean,
        default: false,
      },
      depth: {
        type: Number,
        default: 0,
      },
      parentAnswerGroup: {
        type: Object,
        default: () => null,
      },
      parentCreateAnswerGroup: {
        type: Function,
        default: null,
      },
      refreshForm: Function,
    },
    components: {
      DynamicFormShard,
    },
    computed: {
      options() {
        if (this.link) {
          return this.link.options;
        }

        return {};
      },
      readOnlyOption() {
        if (this.readOnly || this.options.read_only) {
          return true;
        }
        return false;
      },
      shard() {
        if (this.link) {
          return this.link.shard;
        }

        return null;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
